import {useCallback, useRef} from "react";


export const useMap = () => {
    // ref is need to call flyTo and other methods on the map
    const mapRef = useRef(null);
    const mapBoxRef = useRef(null);

    const flyTo = useCallback(({lat, lng}) => {
        const latLng = {lat: lat, lng: lng};

        if(latLng.lat !== null && latLng.lng !== null){
            mapRef?.current?.flyTo(latLng, 12, {duration: 1});
            mapBoxRef?.current?.scrollIntoView({ behavior: 'smooth', block: "center" });  // block center allow to scroll enough to prevent the map to be partially hidden by the app bat
        }
    }, []);

    return {
        mapRef,
        mapBoxRef,
        flyTo
    };
}

export default useMap;